module.exports = __webpack_public_path__ + "img/vendor4.ed1a02ec.webp";